import { SessionPreviewPointDto, SessionKindGroupName, prefersTopView } from 'types/models/SessionsPageData';
import { SessionCardPreviewPoint, SessionCardPreviewReachableSegment } from './components/SessionCardPreview';
import { mapTopPreviewPoint, mapGoalPreviewPoint, mapTopPreviewReachablePoint } from './charts/previewCoordinateMapping';

export function buildSessionPreview(
  kind: SessionKindGroupName,
  sessionMeasurements: SessionPreviewPointDto[],
): { mode: 'top' | 'goal'; points: SessionCardPreviewPoint[]; reachableSegments: SessionCardPreviewReachableSegment[] } {
  const mode = prefersTopView(kind) ? 'top' : 'goal';
  const points: SessionCardPreviewPoint[] = sessionMeasurements
    .map((m) => {
      const p = mode === 'top' ? mapTopPreviewPoint(m, kind) : mapGoalPreviewPoint(m);
      return p ? { ...p, result: m.result, kind } : null;
    })
    .filter((p): p is { xPct: number; yPct: number; result: string; kind: SessionKindGroupName } => p !== null)
    .slice(0, 18);
  const reachableSegments = mode !== 'top' ? [] : sessionMeasurements
    .filter((m) => m.reachableRegionStart && m.reachableRegionEnd)
    .map((m) => {
      const start = mapTopPreviewReachablePoint(m.reachableRegionStart as [number, number], m);
      const end = mapTopPreviewReachablePoint(m.reachableRegionEnd as [number, number], m);
      if (!start || !end) return null;
      return { startXPct: start.xPct, startYPct: start.yPct, endXPct: end.xPct, endYPct: end.yPct, onTarget: m.onTarget, measurementId: m.id };
    })
    .filter((s): s is SessionCardPreviewReachableSegment => s !== null)
    .slice(0, 12);
  return { mode, points, reachableSegments };
}
